import React from 'react';
import { companyDetailsLine } from './businessDetails';

/**
 * Shared business legal details form: the Marketing Settings card and the
 * pre-send gate in both campaign composers render this same component, so
 * the fields and validation stay identical everywhere.
 *
 * Props: value (details object), onChange(field, value), prefillAddress.
 */

const inputStyle = { width: '100%', height: '44px', padding: '0 14px', boxSizing: 'border-box', border: '1px solid #ECECF0', borderRadius: '10px', fontSize: '14px', fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff' };
const labelStyle = { display: 'block', fontSize: '12.5px', fontWeight: 600, color: '#4B4B52', margin: '0 0 6px' };

const BusinessDetailsForm = ({ value, onChange, prefillAddress }) => {
  const v = value || {};
  return (
    <div>
      <label style={labelStyle}>How is your business set up?</label>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '18px', flexWrap: 'wrap' }}>
        {[
          { id: 'self-employed', label: 'Self-employed / sole trader' },
          { id: 'ltd', label: 'Limited company' },
        ].map(opt => (
          <button
            key={opt.id}
            type='button'
            onClick={() => onChange('legalForm', opt.id)}
            style={{
              padding: '10px 18px', borderRadius: '100px', fontSize: '13px', fontWeight: 600,
              border: v.legalForm === opt.id ? '2px solid #29282D' : '1px solid #ECECF0',
              background: v.legalForm === opt.id ? '#29282D' : '#fff',
              color: v.legalForm === opt.id ? '#fff' : '#4B4B52',
              cursor: 'pointer', fontFamily: 'inherit'
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {v.legalForm === 'ltd' && (
        <div style={{ display: 'grid', gap: '14px' }}>
          <div>
            <label style={labelStyle}>Registered company name</label>
            <input style={inputStyle} type='text' value={v.registeredName || ''} onChange={e => onChange('registeredName', e.target.value)} placeholder='e.g. Glow Studio Ltd' />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '14px' }}>
            <div>
              <label style={labelStyle}>Company number</label>
              <input style={inputStyle} type='text' value={v.companyNumber || ''} onChange={e => onChange('companyNumber', e.target.value)} placeholder='e.g. 12345678' />
            </div>
            <div>
              <label style={labelStyle}>Place of registration</label>
              <select style={{ ...inputStyle, appearance: 'auto' }} value={v.placeOfRegistration || 'England and Wales'} onChange={e => onChange('placeOfRegistration', e.target.value)}>
                <option>England and Wales</option>
                <option>Scotland</option>
                <option>Northern Ireland</option>
              </select>
            </div>
          </div>
          <div>
            <label style={labelStyle}>Registered office address</label>
            <input style={inputStyle} type='text' value={v.registeredOffice || ''} onChange={e => onChange('registeredOffice', e.target.value)} placeholder={prefillAddress || 'Your registered office address'} />
            {prefillAddress && !v.registeredOffice && (
              <button type='button' onClick={() => onChange('registeredOffice', prefillAddress)} style={{ border: 'none', background: 'none', padding: '6px 0 0', fontSize: '12.5px', fontWeight: 600, color: '#007EA0', cursor: 'pointer', fontFamily: 'inherit' }}>
                Use my salon address
              </button>
            )}
          </div>
        </div>
      )}

      {v.legalForm === 'self-employed' && (
        <div>
          <label style={labelStyle}>Trading name (optional)</label>
          <input style={inputStyle} type='text' value={v.tradingName || ''} onChange={e => onChange('tradingName', e.target.value)} placeholder='Only if you trade under a different name' />
          <p style={{ fontSize: '12.5px', color: '#8E8E93', margin: '8px 0 0' }}>Your salon name and address already appear on every marketing email, which covers the legal requirement for sole traders.</p>
        </div>
      )}

      {v.legalForm && companyDetailsLine(v) ? (
        <div style={{ marginTop: '16px', padding: '12px 14px', background: '#F2F2F7', borderRadius: '10px' }}>
          <p style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: '#8E8E93', margin: '0 0 4px' }}>Footer preview</p>
          <p style={{ fontSize: '12.5px', color: '#4B4B52', margin: 0 }}>{companyDetailsLine(v)}</p>
        </div>
      ) : null}
    </div>
  );
};

export default BusinessDetailsForm;
